<form [formGroup]="formGroup">

    <app-form-field [type]="fields.title.type" [options]="fields.title.options"></app-form-field>
	<app-form-field [type]="fields.category_id.type" [options]="fields.category_id.options"></app-form-field>
	<app-form-field [type]="fields.type.type" [options]="fields.type.options"></app-form-field>
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
